// Only list of kredsrette, however they have courts within them, these might be necessary to add later
export const GLcourts = [
    {
        courtId: 'fb80e6c6-3da6-4bb3-86f2-b8bed207b95a',
        name: 'Retten i Grønland',
        phone: '363800',
        email: 'post.rig@domstol.gl',
        emailFogedret: 'post.rig@domstol.gl',
        emailFogedretRevideretBPK: 'post.rig@domstol.gl',
        emailFogedretIndleveringBPK: 'post.rig@domstol.gl',
        emailFogedretIndleveringFogedrekvisition: 'post.rig@domstol.gl',
        eanno: '',
        address: 'Jens Kreutzmannip Aqqutaa 1',
        zipcode: '3900',
        city: 'Nuuk',
        id: 'gl-1',
        country: 'GL',
        registrationnumber: '6471',
        accountnumber: '1032663',
    },
    {
        courtId: '538d7bc0-fb2b-44dd-a205-9d4196cdb9b0',
        name: 'Sermersooq Kredsret',
        phone: '363800',
        email: 'sermersooq@domstol.gl',
        emailFogedret: 'sermersooq@domstol.gl',
        emailFogedretRevideretBPK: 'sermersooq@domstol.gl',
        emailFogedretIndleveringBPK: 'sermersooq@domstol.gl',
        emailFogedretIndleveringFogedrekvisition: 'sermersooq@domstol.gl',
        eanno: '',
        address: 'Jens Kreutzmannip Aqqutaa 1',
        zipcode: '3900',
        city: 'Nuuk',
        id: 'gl-2',
        country: 'GL',
        registrationnumber: '6471',
        accountnumber: '1032663',
    },
    {
        courtId: '037c8a7b-fa4c-46df-906b-b210fdd79eff',
        name: 'Qeqqa Kredsret',
        phone: '363808',
        email: 'foged.qeq@domstol.gl',
        emailFogedret: 'foged.qeq@domstol.gl',
        emailFogedretRevideretBPK: 'foged.qeq@domstol.gl',
        emailFogedretIndleveringBPK: 'foged.qeq@domstol.gl',
        emailFogedretIndleveringFogedrekvisition: 'foged.qeq@domstol.gl',
        eanno: '',
        address: 'Nalunnguarfimmut 2',
        zipcode: '3911',
        city: 'Sisimiut',
        id: 'gl-3',
        country: 'GL',
        registrationnumber: '6471',
        accountnumber: '1032663',
    },
    {
        courtId: '30a997a8-4be9-4c38-a329-c332b3fb3414',
        name: 'Kujalleq Kredsret',
        phone: '363802',
        email: 'kujalleq@domstol.gl',
        emailFogedret: 'kujalleq@domstol.gl',
        emailFogedretRevideretBPK: 'kujalleq@domstol.gl',
        emailFogedretIndleveringBPK: 'kujalleq@domstol.gl',
        emailFogedretIndleveringFogedrekvisition: 'kujalleq@domstol.gl',
        eanno: '',
        address: 'Aaninngivit B-1672',
        zipcode: '3920',
        city: 'Qaqortoq',
        id: 'gl-4',
        country: 'GL',
        registrationnumber: '6471',
        accountnumber: '1032663',
    },
    {
        courtId: '64506644-5b69-4a43-b5cf-985b4b1e1edb',
        name: 'Qaasuitsoq Kredsret',
        phone: '363812',
        email: 'qaasuitsoq@domstol.gl',
        emailFogedret: 'qaasuitsoq@domstol.gl',
        emailFogedretRevideretBPK: 'qaasuitsoq@domstol.gl',
        emailFogedretIndleveringBPK: 'qaasuitsoq@domstol.gl',
        emailFogedretIndleveringFogedrekvisition: 'qaasuitsoq@domstol.gl',
        eanno: '',
        address: 'Jørgen Sverdrupip Aqq. 2',
        zipcode: '3952',
        city: 'Ilulissat',
        id: 'gl-5',
        country: 'GL',
        registrationnumber: '6471',
        accountnumber: '1032663',
    },
];
//# sourceMappingURL=greenland.js.map